import { SxProps } from '@mui/material';
import { StackColumn, StackRow } from 'src/components';

//
//

type MenuColumnProps = {
  showBackground?: boolean;
  gap?: number;
  children: React.ReactNode | React.ReactNode[];
  sx?: SxProps;
};

export const MenuColumn: React.FC<MenuColumnProps> = ({ showBackground, children, ...props }) => {
  return (
    <StackColumn
      flex={1}
      p={4}
      sx={{ backgroundColor: (theme) => (showBackground ? theme.palette.primary.lighter : '') }}
      gap={3}
      {...props}
    >
      {children}
    </StackColumn>
  );
};

//

type MenuRowProps = {
  children: React.ReactNode | React.ReactNode[];
};

export const MenuRow: React.FC<MenuRowProps> = ({ children }) => {
  return (
    <StackRow display="flex" gap={0} alignItems="stretch" flex={1}>
      {children}
    </StackRow>
  );
};
